/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pdf': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 7)" _stroke="#00272E"><path pid="0" d="M15.366 3.375c.15.14.234.331.234.53v12.97c0 .414-.358.75-.8.75H1.2c-.442 0-.8-.336-.8-.75V1.125c0-.414.358-.75.8-.75h10.634c.212 0 .416.078.566.218l2.966 2.782z"/><path pid="1" d="M4.875 6.14c-.547-.85.762-1.63 1.104-.759.585 1.496 1.527 5.543-.598 8.294-.592.766-1.87.04-1.183-.758 1.994-2.218 4.928-3.488 8.011-3.465 1.073.038 1.017 1.475.058 1.364-3.103-.383-5.838-2.113-7.392-4.676z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/pdf.js